import type { BareBonesDayjs } from '~/types/utils'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import objectSupport from 'dayjs/plugin/objectSupport'

interface DateObjectSupport {
  year: number | string
  month: number | string
  day: number | string
}

dayjs.extend(objectSupport)

export function dayjsUTC(dateObj?: DateObjectSupport): Dayjs {
  return dateObj
    ? dayjs.utc({
        day: dateObj.day,
        month: dateObj.month,
        year: dateObj.year
      })
    : dayjs().utc()
}

export function parseBareBonesDayjs(
  bareBonesDayJs?: BareBonesDayjs | null
): Dayjs | null {
  if (!bareBonesDayJs) {
    return null
  }
  return dayjs({
    year: bareBonesDayJs.$y,
    month: bareBonesDayJs.$M,
    day: bareBonesDayJs.$D,
    hour: bareBonesDayJs.$H,
    minute: bareBonesDayJs.$m,
    second: bareBonesDayJs.$s,
    millisecond: bareBonesDayJs.$ms
  })
}
